export default "/images/cd587eeca7209a49aa3dd55c91129b0f.png";